module.exports = __webpack_public_path__ + "img/bank-mandiri.5fa12c5c.png";